import { createSelector } from '@ngrx/store';

import { BlockState } from '../state/block.state';
import { selectBlockState } from './block.selectors';
import { selectSystemState } from './system.selectors';

export const selectSystemEnergyDataOverview = createSelector(
  selectBlockState,
  (state: BlockState) => state.blockList.EnergyDataOverviewComponent
);

export const selectSystemEnergyStateBySelectedSystem = (instanceId: string) => createSelector(
  selectSystemState,
  selectSystemEnergyDataOverview,
  (systemState, energyDataOverviewComponent) => {
    const selectedSystem = systemState.selectedSystemUid;
    if (!selectedSystem) {
      return null;
    }

    const instanceBlock = energyDataOverviewComponent[instanceId];
    if (!instanceBlock) {
      return null;
    }

    return instanceBlock[selectedSystem]?.systemEnergyState;
  }
);

export const selectedEnergyDataOverviewRequestStatus = (instanceId: string) => createSelector(
  selectSystemState,
  selectSystemEnergyDataOverview,
  (systemState, energyDataOverviewComponent) => {
    const selectedSystem = systemState.selectedSystemUid;
    if (!selectedSystem) {
      return null;
    }

    const instanceBlock = energyDataOverviewComponent[instanceId];
    if (!instanceBlock) {
      return null;
    }

    return instanceBlock[selectedSystem]?.state;
  }
);